import { render, staticRenderFns } from "./FormDiscussion.vue?vue&type=template&id=08f91112"
import script from "./FormDiscussion.vue?vue&type=script&lang=js"
export * from "./FormDiscussion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports